<template>
  <div v-if="$keycloak.hasRealmRole('billadmin')">
    <h1>Bill templates</h1>
    <v-data-table
      v-if="billTemplates"
      :headers="headers"
      :items="billTemplates"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{ name: 'billTemplate', params: { id: props.item.id } }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.name }}</td>
          <td>
            <router-link
              :to="{ name: 'category', params: { id: props.item.category.id } }"
              v-if="props.item.category"
              >{{ props.item.category.shortname }}</router-link
            >
            <span v-if="!props.item.category">{{ props.item.categoryid }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-progress-circular indeterminate color="info" v-if="!billTemplates" />
  </div>
</template>

<script>
import BILL_TEMPLATES from "@/graphql/accounts/billTemplate/BillTemplates";
export default {
  name: "BillTemplates",
  metaInfo() {
    return {
      title: "Bill templates",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    billTemplates: {
      query: BILL_TEMPLATES,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      headers: [
        {
          text: "id",
          value: "id"
        },
        {
          text: "name",
          value: "name"
        },
        {
          text: "category",
          value: "category.shortname"
        }
      ]
    };
  }
};
</script>
